module.exports = __webpack_public_path__ + "img/5_OIL_&_GAS.3c26e6d7.png";